class HostageSleepQuiz extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.currentScreen = 0;
    this.answers = {};
  }

  connectedCallback() {
    this.render();
    this.attachEventListeners();
    try { if(typeof fbq==='function') fbq('trackCustom','QuizStarted'); } catch(e){}
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        :host { display: block; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; }
        .quiz-root { max-width: 640px; margin: 0 auto; padding: 20px 16px 40px; min-height: 100vh; }
        .logo { text-align: center; padding: 20px 0 16px; }
        .logo img { height: 40px; }
        .logo-sub { font-size: 11px; letter-spacing: 3px; text-transform: uppercase; color: #666; margin-top: 2px; }

        .screen { display: none; animation: fadeIn 0.35s ease; }
        .screen.active { display: block; }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }

        .progress-bar { width: 100%; height: 6px; background: #e0e0e0; border-radius: 3px; margin: 0 0 24px; overflow: hidden; }
        .progress-fill { height: 100%; background: #000; border-radius: 3px; transition: width 0.4s ease; }

        h2 { font-size: 26px; font-weight: 800; text-align: center; color: #000; line-height: 1.25; margin-bottom: 20px; }
        .subtext { text-align: center; color: #555; font-size: 15px; line-height: 1.5; margin-bottom: 20px; }
        .subtext .check { color: #22c55e; }

        .testimonial { background: #fff8f0; border-radius: 12px; padding: 16px 20px; margin-bottom: 24px; text-align: center; }
        .testimonial p { font-style: italic; color: #333; font-size: 14px; line-height: 1.5; margin-bottom: 8px; }
        .testimonial .author { font-weight: 700; font-style: normal; color: #000; font-size: 13px; }

        .options { display: flex; flex-direction: column; gap: 10px; }
        .option { display: flex; align-items: center; gap: 12px; padding: 16px 18px; background: #fff; border: 2px solid #e5e5e5; border-radius: 12px; cursor: pointer; transition: all 0.2s ease; font-size: 16px; color: #1a1a1a; }
        .option:hover { border-color: #999; }
        .option.selected { border-color: #000; background: #000; color: #fff; }
        .option .num { width: 28px; height: 28px; border-radius: 50%; background: #f0f0f0; display: flex; align-items: center; justify-content: center; font-size: 13px; font-weight: 700; color: #666; flex-shrink: 0; }
        .option.selected .num { background: #fff; color: #000; }
        .option .emoji { font-size: 20px; flex-shrink: 0; }

        .micro-copy { background: #f8f9fa; border-left: 3px solid #0B61CD; padding: 12px 16px; margin-top: 16px; border-radius: 0 8px 8px 0; font-size: 13px; color: #555; line-height: 1.5; }
        .micro-copy strong { color: #000; }

        .btn { display: block; width: 100%; padding: 18px; background: #000; color: #fff; border: none; border-radius: 12px; font-size: 18px; font-weight: 700; cursor: pointer; margin-top: 20px; transition: background 0.2s; text-transform: uppercase; letter-spacing: 1px; }
        .btn:hover { background: #222; }
        .btn.cta { background: #dc2626; font-size: 20px; padding: 20px; }
        .btn.cta:hover { background: #b91c1c; }

        .interstitial { text-align: center; padding: 20px 0; }
        .interstitial h2 { color: #000; margin-bottom: 16px; }
        .interstitial p { font-size: 15px; line-height: 1.6; color: #333; margin-bottom: 16px; }
        .interstitial .stat-callout { background: #f0f7ff; border: 2px solid #0B61CD; border-radius: 12px; padding: 16px 20px; margin: 20px 0; }
        .interstitial .stat-callout .stat-number { font-size: 36px; font-weight: 900; color: #0B61CD; }
        .interstitial .stat-callout .stat-text { font-size: 14px; color: #333; margin-top: 4px; }



        .loading-screen { text-align: center; padding: 40px 0; }
        .loading-screen h2 { margin-bottom: 30px; }
        .loading-steps { display: flex; flex-direction: column; gap: 16px; max-width: 320px; margin: 0 auto; }
        .loading-step { display: flex; align-items: center; gap: 12px; font-size: 15px; color: #999; transition: color 0.3s; }
        .loading-step.done { color: #000; }
        .loading-step .step-icon { width: 24px; height: 24px; border-radius: 50%; border: 2px solid #ddd; display: flex; align-items: center; justify-content: center; transition: all 0.3s; flex-shrink: 0; }
        .loading-step.done .step-icon { background: #22c55e; border-color: #22c55e; color: #fff; }
        .loading-step.done .step-icon::after { content: ''; display: block; width: 6px; height: 10px; border: solid #fff; border-width: 0 2px 2px 0; transform: rotate(45deg); margin-top: -2px; }
        .spinner { width: 40px; height: 40px; border: 3px solid #e5e5e5; border-top-color: #000; border-radius: 50%; animation: spin 0.8s linear infinite; margin: 20px auto 0; }
        @keyframes spin { to { transform: rotate(360deg); } }

        .results-card { background: #fff; border-radius: 16px; padding: 24px; margin-bottom: 20px; box-shadow: 0 2px 12px rgba(0,0,0,0.08); }
        .results-card h3 { font-size: 18px; margin-bottom: 12px; color: #000; }

        .results-profile { display: flex; align-items: center; gap: 16px; margin-bottom: 20px; padding-bottom: 20px; border-bottom: 1px solid #eee; }
        .results-profile-img { width: 80px; height: 80px; border-radius: 50%; object-fit: cover; border: 3px solid #000; }
        .results-profile-info { flex: 1; }
        .results-profile-name { font-size: 18px; font-weight: 800; color: #000; margin-bottom: 4px; }
        .results-profile-detail { font-size: 13px; color: #666; line-height: 1.4; }

        .gauge-section { text-align: center; margin-bottom: 20px; }
        .gauge-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
        .gauge-title { font-size: 18px; font-weight: 800; color: #000; text-align: left; }
        .gauge-badge { display: inline-block; padding: 4px 12px; border: 2px solid #dc2626; border-radius: 6px; font-size: 12px; font-weight: 800; color: #dc2626; letter-spacing: 1px; text-transform: uppercase; }
        .gauge-track { position: relative; width: 100%; height: 12px; border-radius: 6px; background: linear-gradient(to right, #22c55e 0%, #eab308 40%, #f97316 65%, #dc2626 100%); margin: 0 0 8px; }
        .gauge-indicator { position: absolute; top: 50%; transform: translate(-50%, -50%); width: 24px; height: 24px; border-radius: 50%; background: #fff; border: 3px solid #000; box-shadow: 0 2px 6px rgba(0,0,0,0.3); transition: left 1s ease; }
        .gauge-label-container { position: relative; width: 100%; height: 28px; margin-bottom: 4px; }
        .gauge-pointer-label { position: absolute; transform: translateX(-50%); background: #000; color: #fff; font-size: 11px; font-weight: 700; padding: 3px 10px; border-radius: 4px; white-space: nowrap; top: 0; letter-spacing: 0.5px; }
        .gauge-pointer-label::after { content: ''; position: absolute; bottom: -5px; left: 50%; transform: translateX(-50%); border-left: 5px solid transparent; border-right: 5px solid transparent; border-top: 5px solid #000; }
        .gauge-labels { display: flex; justify-content: space-between; font-size: 11px; font-weight: 700; color: #888; text-transform: uppercase; letter-spacing: 1px; margin-top: 4px; }

        .alert-card { background: #fef2f2; border: 1px solid #fecaca; border-radius: 12px; padding: 16px 18px; margin: 20px 0; display: flex; gap: 14px; align-items: flex-start; }
        .alert-icon { width: 44px; height: 44px; background: #dc2626; border-radius: 8px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
        .alert-icon span { color: #fff; font-size: 24px; font-weight: 900; }
        .alert-content h4 { font-size: 15px; font-weight: 800; color: #000; margin-bottom: 4px; }
        .alert-content p { font-size: 13px; color: #555; line-height: 1.5; }
        .alert-content strong { color: #dc2626; }

        .metrics-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin: 16px 0; }
        .metric-card { background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 10px; padding: 14px 16px; display: flex; align-items: center; gap: 10px; }
        .metric-icon { font-size: 22px; flex-shrink: 0; }
        .metric-label { font-size: 10px; font-weight: 700; color: #888; text-transform: uppercase; letter-spacing: 0.5px; }
        .metric-value { font-size: 15px; font-weight: 800; color: #000; margin-top: 1px; }

        .clinical-proof { background: #f0fdf4; border: 2px solid #22c55e; border-radius: 12px; padding: 20px; margin: 20px 0; }
        .clinical-proof h3 { font-size: 16px; font-weight: 800; color: #000; margin-bottom: 12px; text-align: center; }
        .clinical-proof .proof-item { display: flex; align-items: flex-start; gap: 10px; margin-bottom: 10px; font-size: 14px; color: #333; line-height: 1.4; }
        .clinical-proof .proof-item .proof-check { color: #22c55e; font-weight: 700; flex-shrink: 0; font-size: 16px; }
        .clinical-proof .proof-source { font-size: 11px; color: #888; margin-top: 8px; font-style: italic; text-align: center; }

        .pitch-section { text-align: center; }
        .pitch-section .product-img { width: 100%; max-width: 360px; border-radius: 12px; margin: 20px auto; display: block; }
        .pitch-section .benefit { display: flex; align-items: flex-start; gap: 10px; text-align: left; padding: 8px 0; font-size: 15px; color: #333; }
        .pitch-section .benefit .icon { color: #22c55e; font-size: 18px; flex-shrink: 0; margin-top: 1px; }

        .offer-section { text-align: center; }
        .offer-section .price-block { margin: 20px 0; }
        .offer-section .price-old { font-size: 22px; color: #999; text-decoration: line-through; }
        .offer-section .price-new { font-size: 42px; font-weight: 900; color: #000; }
        .offer-section .price-save { display: inline-block; background: #dcfce7; color: #16a34a; padding: 4px 12px; border-radius: 20px; font-size: 14px; font-weight: 700; margin-top: 8px; }
        .offer-section .guarantee { display: flex; align-items: center; justify-content: center; gap: 8px; margin-top: 16px; padding: 12px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px; font-size: 14px; color: #166534; }
        .offer-section .guarantee .shield { font-size: 20px; }
        .offer-section .trust-badges { display: flex; justify-content: center; gap: 24px; margin-top: 16px; font-size: 13px; color: #666; }

        .footer { text-align: center; padding: 24px 0 0; font-size: 12px; color: #999; }
        .footer a { color: #999; text-decoration: underline; }
      </style>

      <div class="quiz-root">
        <div class="logo">
          <img src="https://hostagetape.com/cdn/shop/files/Brand_Logos_2x_72f465c3-6145-4bd2-9d80-9ba07b094816.png?v=1723530116&width=252" alt="Hostage Tape" />
          <div class="logo-sub">Sleep Assessment</div>
        </div>

        <div class="progress-bar"><div class="progress-fill" id="progress" style="width:0%"></div></div>

        <!-- SCREEN 0: Q1 - Age -->
        <div class="screen active" data-screen="0">
          <h2>Let\u2019s find out what\u2019s holding your sleep hostage.</h2>
          <p class="subtext"><span class="check">&#10003;</span> This 2-minute assessment analyzes your sleep habits to find the root cause and a solution.</p>
          <div class="testimonial">
            <p>"I was skeptical, but after one night with Hostage Tape I slept through till 6am for the first time in years. My wife says the snoring is completely gone."</p>
            <div class="author">MIKE R., Verified Customer</div>
          </div>
          <h2 style="font-size:22px;">First, how old are you?</h2>
          <div class="options" data-question="age">
            <div class="option" data-value="50+"><span class="num">1</span> 50+ Years Old</div>
            <div class="option" data-value="40-49"><span class="num">2</span> 40 - 49 Years Old</div>
            <div class="option" data-value="30-39"><span class="num">3</span> 30 - 39 Years Old</div>
            <div class="option" data-value="20-29"><span class="num">4</span> 20 - 29 Years Old</div>
          </div>
        </div>

        <!-- SCREEN 1: Q2 - Functional Symptom -->
        <div class="screen" data-screen="1">
          <h2>When you wake up in the morning, what is the first thing you notice?</h2>
          <div class="options" data-question="symptom">
            <div class="option" data-value="dry-mouth"><span class="num">1</span> My mouth is completely dry and my throat hurts.</div>
            <div class="option" data-value="tired"><span class="num">2</span> I feel like I barely slept, even after 8 hours.</div>
            <div class="option" data-value="snoring"><span class="num">3</span> My partner is annoyed because I was snoring again.</div>
            <div class="option" data-value="restless"><span class="num">4</span> I\u2019m exhausted from tossing and turning all night.</div>
          </div>
        </div>

        <!-- SCREEN 2: Q3 - Functional Energy Check -->
        <div class="screen" data-screen="2">
          <h2>How do you feel when the 2 PM afternoon slump hits?</h2>
          <div class="options" data-question="energy">
            <div class="option" data-value="crashing"><span class="num">1</span> I\u2019m completely crashing. I need caffeine or a nap to survive.</div>
            <div class="option" data-value="low"><span class="num">2</span> Noticeably lower. I\u2019m pushing through, but it\u2019s hard.</div>
            <div class="option" data-value="okay"><span class="num">3</span> Slightly tired, but I\u2019m still functional.</div>
            <div class="option" data-value="great"><span class="num">4</span> I don\u2019t get an afternoon crash.</div>
          </div>
          <div class="micro-copy">Most people think afternoon crashes are normal. They aren\u2019t. They are a sign your body didn\u2019t get deep, restorative sleep the night before.</div>
        </div>

        <!-- SCREEN 3: Q4 - Partner/Snoring Check -->
        <div class="screen" data-screen="3">
          <h2>Has your partner ever complained about your snoring, or have you woken yourself up gasping for air?</h2>
          <div class="options" data-question="snoring">
            <div class="option" data-value="constantly"><span class="num">1</span> Yes, my partner complains about it constantly.</div>
            <div class="option" data-value="sometimes"><span class="num">2</span> Sometimes, but it\u2019s not every night.</div>
            <div class="option" data-value="gasping"><span class="num">3</span> I\u2019ve woken myself up gasping before.</div>
            <div class="option" data-value="no"><span class="num">4</span> No, I sleep quietly.</div>
          </div>
          <div class="micro-copy">In a recent clinical study, participants who fixed their nighttime breathing reported a <strong>78.9% reduction</strong> in their struggle with snoring.</div>
        </div>

        <!-- SCREEN 4: Q5 - Mouth Breathing Check -->
        <div class="screen" data-screen="4">
          <h2>Have you ever woken up in the middle of the night with your mouth wide open?</h2>
          <div class="options" data-question="mouth_open">
            <div class="option" data-value="yes"><span class="num">1</span> Yes, all the time.</div>
            <div class="option" data-value="probably"><span class="num">2</span> Probably, but I\u2019m not entirely sure.</div>
            <div class="option" data-value="partner-says"><span class="num">3</span> My partner says I do.</div>
            <div class="option" data-value="no"><span class="num">4</span> No, I definitely breathe through my nose.</div>
          </div>
        </div>

        <!-- SCREEN 5: Interstitial Info Slide -->
        <div class="screen" data-screen="5">
          <div class="interstitial">
            <h2>The Hidden Cause of Bad Sleep</h2>
            <p>Based on your answers, you are showing signs of <strong>nighttime mouth breathing</strong>.</p>
            <p>When you breathe through your mouth, your airway resistance increases, causing snoring and preventing your body from entering deep sleep.</p>
            <div class="stat-callout">
              <div class="stat-number">45.4%</div>
              <div class="stat-text">In a recent SleepSpace clinical study, participants who switched to nasal breathing saw a <strong>45.4% increase</strong> in their deep sleep ratings.</div>
            </div>
            <button class="btn" id="interstitial-continue">Continue</button>
          </div>
        </div>

        <!-- SCREEN 6: Q6 - The Goal -->
        <div class="screen" data-screen="6">
          <h2>If you could fix one thing about your sleep tonight, what would it be?</h2>
          <div class="options" data-question="goal">
            <div class="option" data-value="stop-snoring"><span class="num">1</span> Stop snoring so my partner and I can actually rest.</div>
            <div class="option" data-value="energy"><span class="num">2</span> Wake up with real energy instead of feeling groggy.</div>
            <div class="option" data-value="dry-throat"><span class="num">3</span> Stop waking up with a dry, painful throat.</div>
            <div class="option" data-value="deep-sleep"><span class="num">4</span> Finally get deep, uninterrupted sleep.</div>
          </div>
        </div>

        <!-- SCREEN 7: Q7 - Beard Check -->
        <div class="screen" data-screen="7">
          <h2>Do you have facial hair or a beard?</h2>
          <div class="options" data-question="beard">
            <div class="option" data-value="full-beard"><span class="emoji">\uD83E\uDDD4</span> Full beard</div>
            <div class="option" data-value="stubble"><span class="emoji">\uD83E\uDDD1</span> Stubble / short facial hair</div>
            <div class="option" data-value="clean"><span class="emoji">\uD83D\uDE0A</span> Clean shaven</div>
          </div>
          <div class="micro-copy">We ask because many guys think our solution won\u2019t work with a beard. Our extra-strength adhesive is designed specifically to hold through facial hair.</div>
        </div>

        <!-- SCREEN 8: Loading Animation -->
        <div class="screen" data-screen="8">
          <div class="loading-screen">
            <h2>Analyzing your sleep profile...</h2>
            <div class="loading-steps" id="analysis-steps">
              <div class="loading-step" data-delay="800"><span class="step-icon"></span> Reviewing your sleep patterns</div>
              <div class="loading-step" data-delay="1800"><span class="step-icon"></span> Checking airway factors</div>
              <div class="loading-step" data-delay="2800"><span class="step-icon"></span> Identifying root causes</div>
              <div class="loading-step" data-delay="3800"><span class="step-icon"></span> Finalizing results</div>
            </div>
            <div class="spinner"></div>
          </div>
        </div>

        <!-- SCREEN 9: Results Page -->
        <div class="screen" data-screen="9">
          <h2>Summary of Your Sleep Profile</h2>
          <div class="results-card">
            <div class="results-profile">
              <img class="results-profile-img" id="results-guy-img" src="https://cdn.shopify.com/s/files/1/0586/6520/5927/t/150/assets/quiz-guy-clean.png" alt="Your Profile" />
              <div class="results-profile-info">
                <div class="results-profile-name" id="results-profile-label">Your Sleep Profile</div>
                <div class="results-profile-detail" id="results-profile-desc">Based on your answers, here is your personalized sleep disruption assessment.</div>
              </div>
            </div>
            <div class="gauge-section">
              <div class="gauge-header">
                <span class="gauge-title">Level of Sleep Disruption</span>
                <span class="gauge-badge" id="gauge-badge">HIGH LEVEL</span>
              </div>
              <div style="position:relative;">
                <div class="gauge-label-container">
                  <div class="gauge-pointer-label" id="gauge-pointer-label" style="left:75%;">YOUR LEVEL</div>
                </div>
                <div class="gauge-track">
                  <div class="gauge-indicator" id="gauge-indicator" style="left:75%;"></div>
                </div>
                <div class="gauge-labels">
                  <span>LOW</span><span>NORMAL</span><span>MEDIUM</span><span>HIGH</span>
                </div>
              </div>
            </div>
            <div class="alert-card">
              <div class="alert-icon"><span>!</span></div>
              <div class="alert-content">
                <h4>Sleep Profile: <strong id="alert-status">NEEDS ATTENTION</strong></h4>
                <p id="alert-desc">You are showing clear signs of nighttime mouth breathing. The good news? It is completely fixable.</p>
              </div>
            </div>
            <div class="metrics-grid">
              <div class="metric-card">
                <span class="metric-icon">\uD83D\uDCC9</span>
                <div><div class="metric-label">PRIMARY SYMPTOM:</div><div class="metric-value" id="result-symptom">Snoring</div></div>
              </div>
              <div class="metric-card">
                <span class="metric-icon">\uD83D\uDCC8</span>
                <div><div class="metric-label">ROOM FOR IMPROVEMENT:</div><div class="metric-value" id="result-improvement">HIGH</div></div>
              </div>
              <div class="metric-card">
                <span class="metric-icon">\u26A1</span>
                <div><div class="metric-label">ENERGY IMPACT:</div><div class="metric-value" id="result-energy">Severe</div></div>
              </div>
              <div class="metric-card">
                <span class="metric-icon">\uD83D\uDCA4</span>
                <div><div class="metric-label">QUALITY OF LIFE IMPACT:</div><div class="metric-value" id="result-quality">Substantial</div></div>
              </div>
            </div>
          </div>
          <div class="clinical-proof">
            <h3>Proven to Work in Clinical Studies</h3>
            <div class="proof-item"><span class="proof-check">\u2713</span> <span>78.9% lower struggle with snoring by Week 3.</span></div>
            <div class="proof-item"><span class="proof-check">\u2713</span> <span>45.4% higher sleep-depth ratings.</span></div>
            <div class="proof-item"><span class="proof-check">\u2713</span> <span>84.6% of users reported improved overall sleep quality.</span></div>
            <p class="proof-source">Data from the SleepSpace x Hostage Tape active-control study.</p>
          </div>
          <button class="btn" style="margin-top:8px;">CONTINUE</button>
        </div>

        <!-- SCREEN 10: 90-Night Transformation Pitch -->
        <div class="screen" data-screen="10">
          <div class="pitch-section">
            <h2>Your 90-Night Transformation Starts Here</h2>
            <p class="subtext">Most people feel a difference the <strong>very first night</strong>. But the real transformation happens over 90 nights. That\u2019s why the Starter Pack gives you a full 90-night supply.</p>
            <p style="font-size:16px;color:#555;margin:0 0 20px;">Start tonight. By <strong class="quiz-target-date" style="color:#0B61CD;"></strong>, you could be operating on a completely different level.</p>
            <div style="position:relative;width:100%;max-width:580px;margin:0 auto 20px;">
              <svg viewBox="0 0 580 320" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:auto;">
                <rect x="0" y="0" width="580" height="320" fill="#f9f9f9" rx="8"/>
                <text x="12" y="58" font-size="11" font-weight="700" fill="#222" font-family="system-ui,sans-serif">PEAK</text>
                <text x="12" y="72" font-size="11" font-weight="700" fill="#222" font-family="system-ui,sans-serif">SLEEP</text>
                <text x="12" y="158" font-size="11" font-weight="600" fill="#888" font-family="system-ui,sans-serif">AVERAGE</text>
                <text x="12" y="172" font-size="11" font-weight="600" fill="#888" font-family="system-ui,sans-serif">SLEEP</text>
                <text x="12" y="258" font-size="11" font-weight="600" fill="#aaa" font-family="system-ui,sans-serif">POOR</text>
                <text x="12" y="272" font-size="11" font-weight="600" fill="#aaa" font-family="system-ui,sans-serif">SLEEP</text>
                <line x1="70" y1="60" x2="560" y2="60" stroke="#e0e0e0" stroke-width="1" stroke-dasharray="4,4"/>
                <line x1="70" y1="160" x2="560" y2="160" stroke="#e0e0e0" stroke-width="1" stroke-dasharray="4,4"/>
                <line x1="70" y1="260" x2="560" y2="260" stroke="#ccc" stroke-width="1"/>
                <line x1="70" y1="40" x2="70" y2="270" stroke="#333" stroke-width="2"/>
                <line x1="70" y1="260" x2="560" y2="260" stroke="#333" stroke-width="2"/>
                <defs><linearGradient id="quizCurveGrad" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#0B61CD" stop-opacity="0.3"/><stop offset="100%" stop-color="#0B61CD" stop-opacity="0.03"/></linearGradient></defs>
                <path d="M70,250 C120,245 160,220 233,180 C280,155 350,110 400,85 C450,68 500,60 545,55 L545,260 L70,260 Z" fill="url(#quizCurveGrad)"/>
                <path d="M70,250 C120,245 160,220 233,180 C280,155 350,110 400,85 C450,68 500,60 545,55" fill="none" stroke="#0B61CD" stroke-width="3" stroke-linecap="round"/>
                <circle cx="70" cy="250" r="6" fill="#222"/>
                <rect x="80" y="232" width="110" height="26" rx="4" fill="#222"/>
                <text x="135" y="250" font-size="11" font-weight="800" fill="#fff" text-anchor="middle" font-family="system-ui,sans-serif">YOU ARE HERE</text>
                <circle cx="233" cy="180" r="5" fill="#0B61CD"/>
                <line x1="233" y1="180" x2="233" y2="260" stroke="#0B61CD" stroke-width="1" stroke-dasharray="3,3"/>
                <text x="233" y="296" font-size="11" font-weight="700" fill="#333" text-anchor="middle" font-family="system-ui,sans-serif">NIGHT 30</text>
                <text x="233" y="310" font-size="10" font-weight="600" fill="#0B61CD" text-anchor="middle" font-family="system-ui,sans-serif" class="quiz-date-30"></text>
                <circle cx="400" cy="85" r="5" fill="#0B61CD"/>
                <line x1="400" y1="85" x2="400" y2="260" stroke="#0B61CD" stroke-width="1" stroke-dasharray="3,3"/>
                <text x="400" y="296" font-size="11" font-weight="700" fill="#333" text-anchor="middle" font-family="system-ui,sans-serif">NIGHT 60</text>
                <text x="400" y="310" font-size="10" font-weight="600" fill="#0B61CD" text-anchor="middle" font-family="system-ui,sans-serif" class="quiz-date-60"></text>
                <circle cx="545" cy="55" r="7" fill="#fff" stroke="#0B61CD" stroke-width="3"/>
                <rect x="420" y="30" width="120" height="24" rx="4" fill="#0B61CD"/>
                <text x="480" y="46" font-size="11" font-weight="800" fill="#fff" text-anchor="middle" font-family="system-ui,sans-serif">GOAL: NIGHT 90</text>
                <text x="545" y="296" font-size="11" font-weight="700" fill="#333" text-anchor="middle" font-family="system-ui,sans-serif">NIGHT 90</text>
                <text x="545" y="310" font-size="10" font-weight="600" fill="#0B61CD" text-anchor="middle" font-family="system-ui,sans-serif" class="quiz-date-90"></text>
                <text x="70" y="296" font-size="11" font-weight="700" fill="#333" text-anchor="middle" font-family="system-ui,sans-serif">TODAY</text>
              </svg>
            </div>
            <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:12px;text-align:center;max-width:560px;margin:0 auto 16px;">
              <div style="padding:10px 6px;background:#f4f7fb;border-radius:8px;">
                <div style="font-size:13px;font-weight:800;color:#0B61CD;margin-bottom:4px;">Night 1-7</div>
                <div style="font-size:12px;color:#444;line-height:1.4;">You wake up and something feels different. More rested. More ready.</div>
              </div>
              <div style="padding:10px 6px;background:#f4f7fb;border-radius:8px;">
                <div style="font-size:13px;font-weight:800;color:#0B61CD;margin-bottom:4px;">Night 30</div>
                <div style="font-size:12px;color:#444;line-height:1.4;">Mornings hit different. Clear-headed, locked in. People start noticing.</div>
              </div>
              <div style="padding:10px 6px;background:#f4f7fb;border-radius:8px;">
                <div style="font-size:13px;font-weight:800;color:#0B61CD;margin-bottom:4px;">Night 90</div>
                <div style="font-size:12px;color:#444;line-height:1.4;">Sharper. Calmer. More energy than you\u2019ve had in years. The edge is real.</div>
              </div>
            </div>
            <div style="text-align:left;margin-top:12px;">
              <div class="benefit"><span class="icon">&#10003;</span> BeardFlex\u2122 + AirFlow\u2122 tech - holds all night, never feel trapped</div>
              <div class="benefit"><span class="icon">&#10003;</span> Trusted by 150,000+ people including Joe Rogan</div>
            </div>
            <p style="font-size:14px;color:#888;margin-top:16px;font-style:italic;">$.57 cents per night. That\u2019s less than a cup of coffee for the best sleep of your life.</p>
            <button class="btn" style="margin-top:24px;">Continue</button>
          </div>
        </div>

        <!-- SCREEN 11: Offer Page -->
        <div class="screen" data-screen="11">
          <div class="offer-section">
            <h2>Claim Your 90-Night Starter Pack</h2>
            <p class="subtext">Because you qualify, we\u2019re giving you <strong>90 nights of Hostage Tape</strong> at our best price, with a full money-back guarantee.</p>
            <img class="product-img" src="https://cdn.shopify.com/s/files/1/0586/6520/5927/t/152/assets/bundle-sleep-starter-pack-49.webp?v=1780603874" alt="Hostage Tape Benefits" style="width:100%;max-width:420px;border-radius:12px;margin:16px auto;display:block;">
            <div class="price-block">
              <div class="price-old">$140</div>
              <div class="price-new">$49</div>
              <div class="price-save">SAVE 65% + $91 of FREE Gifts</div>
              <div style="font-size:14px;color:#333;margin-top:6px;line-height:1.6;">FREE Nose Strips &bull; FREE Nasal Sticks &bull; FREE Storage Tin &bull; FREE Shipping</div>
            </div>
            <button class="btn cta" id="claim-btn">CLAIM YOUR DISCOUNT \u2192</button>
            <div class="guarantee">
              <span class="shield">\uD83D\uDEE1\uFE0F</span>
              <span>90-Day Money-Back Guarantee, No Questions Asked</span>
            </div>
            <div class="trust-badges">
              <span>\uD83D\uDE9A FREE Shipping</span>
              <span>\u2B50 150,000+ Customers</span>
              <span>\uD83C\uDDFA\uD83C\uDDF8 Ships from USA</span>
            </div>
          </div>
        </div>

        <!-- SCREEN 12: Redirect Loading -->
        <div class="screen" data-screen="12">
          <div class="loading-screen">
            <h2>Applying your discount...</h2>
            <div class="spinner"></div>
            <p class="subtext" style="margin-top:20px;">Redirecting you to your offer...</p>
          </div>
        </div>

        <div class="footer">
          \u00A9 Hostage Tape ${new Date().getFullYear()} \u00A0
          <a href="/policies/terms-of-service" target="_blank">Terms of Service</a> \u2022
          <a href="/policies/privacy-policy" target="_blank">Privacy Policy</a>
        </div>
      </div>
    `;
  }

  attachEventListeners() {
    var root = this.shadowRoot;
    var self = this;

    // Single-select options auto-advance
    root.querySelectorAll('.option').forEach(function(opt) {
      opt.addEventListener('click', function() {
        var parent = this.closest('.options');
        parent.querySelectorAll('.option').forEach(function(o) { o.classList.remove('selected'); });
        this.classList.add('selected');
        var question = parent.dataset.question;
        self.answers[question] = this.dataset.value;
        setTimeout(function() { self.goToScreen(self.currentScreen + 1); }, 400);
      });
    });

    // Interstitial continue button
    var interstitialBtn = root.getElementById('interstitial-continue');
    if (interstitialBtn) {
      interstitialBtn.addEventListener('click', function() {
        self.goToScreen(self.currentScreen + 1);
      });
    }

    // Generic continue buttons (not claim, not interstitial)
    root.querySelectorAll('.screen .btn:not(#claim-btn):not(.cta):not(#interstitial-continue)').forEach(function(btn) {
      btn.addEventListener('click', function() {
        self.goToScreen(self.currentScreen + 1);
      });
    });

    // Claim button
    var claimBtn = root.getElementById('claim-btn');
    if (claimBtn) {
      claimBtn.addEventListener('click', function() {
        self.goToScreen(12);
        try { if(typeof fbq==='function') fbq('trackCustom','QuizCompleted'); } catch(e){}
        self.addToCart();
      });
    }
  }

  goToScreen(index) {
    var root = this.shadowRoot;
    var screens = root.querySelectorAll('.screen');
    var totalQuizScreens = 12;

    screens.forEach(function(s) { s.classList.remove('active'); });
    var target = root.querySelector('[data-screen="' + index + '"]');
    if (target) {
      target.classList.add('active');
      this.currentScreen = index;

      var progress = root.getElementById('progress');
      var pct = Math.min(100, Math.round((index / totalQuizScreens) * 100));
      if (progress) progress.style.width = pct + '%';

      window.scrollTo({ top: 0, behavior: 'smooth' });

      if (index === 8) this.runLoadingAnimation('analysis-steps', 8);
      if (index === 9) this.populateResults();
      if (index === 10) {
        var now = new Date();
        var d30 = new Date(now); d30.setDate(d30.getDate()+30);
        var d60 = new Date(now); d60.setDate(d60.getDate()+60);
        var d90 = new Date(now); d90.setDate(d90.getDate()+90);
        var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        function fmtDate(d){ return months[d.getMonth()]+' '+d.getDate(); }
        root.querySelectorAll('.quiz-date-30').forEach(function(el){ el.textContent = fmtDate(d30); });
        root.querySelectorAll('.quiz-date-60').forEach(function(el){ el.textContent = fmtDate(d60); });
        root.querySelectorAll('.quiz-date-90').forEach(function(el){ el.textContent = fmtDate(d90); });
        root.querySelectorAll('.quiz-target-date').forEach(function(el){ el.textContent = fmtDate(d90); });
      }
    }
  }

  runLoadingAnimation(containerId, screenIndex) {
    var root = this.shadowRoot;
    var container = root.getElementById(containerId);
    if (!container) return;
    var steps = container.querySelectorAll('.loading-step');
    var self = this;

    steps.forEach(function(step, i) {
      var delay = parseInt(step.dataset.delay) || (i * 800 + 600);
      setTimeout(function() { step.classList.add('done'); }, delay);
    });

    var delays = Array.from(steps).map(function(s) { return parseInt(s.dataset.delay) || 3000; });
    var maxDelay = Math.max.apply(null, delays);
    setTimeout(function() {
      self.goToScreen(screenIndex + 1);
    }, maxDelay + 1200);
  }

  populateResults() {
    var root = this.shadowRoot;
    var symptomMap = {
      'dry-mouth': 'Dry Mouth / Sore Throat',
      'tired': 'Chronic Fatigue',
      'snoring': 'Snoring',
      'restless': 'Restless Sleep'
    };
    var energyMap = {
      'crashing': 'Severe',
      'low': 'Moderate',
      'okay': 'Mild',
      'great': 'Minimal'
    };

    // Calculate severity score (0-100)
    var score = 50;
    // Symptom scoring
    if (this.answers.symptom === 'dry-mouth' || this.answers.symptom === 'snoring') score += 10;
    if (this.answers.symptom === 'tired') score += 8;
    // Energy scoring
    if (this.answers.energy === 'crashing') score += 20;
    else if (this.answers.energy === 'low') score += 10;
    // Snoring/partner scoring
    if (this.answers.snoring === 'constantly') score += 15;
    else if (this.answers.snoring === 'gasping') score += 12;
    else if (this.answers.snoring === 'sometimes') score += 8;
    // Mouth breathing scoring
    if (this.answers.mouth_open === 'yes') score += 10;
    else if (this.answers.mouth_open === 'partner-says') score += 8;
    else if (this.answers.mouth_open === 'probably') score += 5;

    score = Math.min(95, Math.max(40, score));

    // Determine severity level
    var badgeText, alertStatus, gaugePos;
    if (score >= 75) {
      badgeText = 'HIGH LEVEL'; alertStatus = 'NEEDS ATTENTION'; gaugePos = Math.min(92, 70 + (score - 75) * 1.1);
    } else if (score >= 60) {
      badgeText = 'ELEVATED'; alertStatus = 'ROOM TO IMPROVE'; gaugePos = 55 + (score - 60) * 1;
    } else {
      badgeText = 'MODERATE'; alertStatus = 'COULD BE BETTER'; gaugePos = 35 + (score - 40) * 1;
    }

    // Update guy image based on facial hair answer
    var guyImg = root.getElementById('results-guy-img');
    if (guyImg) {
      var beardVal = this.answers.beard || 'clean';
      var imgMap = {
        'full-beard': 'quiz-guy-beard.png',
        'stubble': 'quiz-guy-stubble.png',
        'clean': 'quiz-guy-clean.png'
      };
      var imgFile = imgMap[beardVal] || 'quiz-guy-clean.png';
      guyImg.src = 'https://cdn.shopify.com/s/files/1/0586/6520/5927/t/150/assets/' + imgFile;
    }

    // Update gauge
    var indicator = root.getElementById('gauge-indicator');
    var pointerLabel = root.getElementById('gauge-pointer-label');
    var badge = root.getElementById('gauge-badge');
    if (indicator) setTimeout(function() { indicator.style.left = gaugePos + '%'; }, 300);
    if (pointerLabel) setTimeout(function() { pointerLabel.style.left = gaugePos + '%'; }, 300);
    if (badge) badge.textContent = badgeText;

    // Update alert card
    var alertStatusEl = root.getElementById('alert-status');
    if (alertStatusEl) alertStatusEl.textContent = alertStatus;

    // Update metrics
    var symptomEl = root.getElementById('result-symptom');
    var energyEl = root.getElementById('result-energy');
    var improvementEl = root.getElementById('result-improvement');
    var qualityEl = root.getElementById('result-quality');

    if (symptomEl) symptomEl.textContent = symptomMap[this.answers.symptom] || 'Sleep Disruption';
    if (energyEl) energyEl.textContent = energyMap[this.answers.energy] || 'Moderate';
    if (improvementEl) improvementEl.textContent = score >= 65 ? 'HIGH' : 'MODERATE';
    if (qualityEl) qualityEl.textContent = score >= 75 ? 'Substantial' : score >= 60 ? 'Significant' : 'Moderate';
  }


  addToCart() {
    try { if(typeof fbq==='function') fbq('trackCustom','QuizOffer',{content_name:'Hostage Tape B2G1',value:49.00,currency:'USD'}); } catch(e){}
    setTimeout(function() { window.location.href = '/products/hostage-mouth-tape-buy-2-get-1-free-90-day-special-offer-free-tin-free-shipping'; }, 2000);
  }
}

customElements.define('hostage-sleep-quiz', HostageSleepQuiz);
